module.exports = __webpack_public_path__ + "src/assets/games/10/50.jpg";